// API configuration settings
export const API_CONFIG = {
  // Base URL for API endpoints
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  
  // Specific endpoint paths
  ENDPOINTS: {
    EXPLAIN: '/api/explain',
    GIT_COMMIT_SUGGESTIONS: '/api/git/genie/suggestions',
    URL_SHORTENER: '/api/web/url-shortener',
    RESUME_SNAPSHOT: '/api/career/snapshot/file',
    JOB_MATCHER: '/api/career/matcher/file',
    INTERVIEW_GENERATOR: '/api/career/questionaires/file'
  }
};

// Helper function to build full API URLs
export const getApiUrl = (endpoint: keyof typeof API_CONFIG.ENDPOINTS, params?: Record<string, string>) => {
  const baseUrl = API_CONFIG.BASE_URL;
  const path = API_CONFIG.ENDPOINTS[endpoint];
  
  // Create the full URL
  let url = `${baseUrl}${path}`;
  
  // Add query parameters if provided
  if (params && Object.keys(params).length > 0) {
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');
    
    url += `?${queryString}`;
  }
  
  return url;
};
